import * as yup from "yup";

export const paymentTypeSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
